import styled from '@emotion/styled';

export const EditProfileFormStyled = {
  Container: styled.div<any>``,
  Separator: styled.div<any>`
    margin-top: 15px;
  `,
  ContainerButton: styled.div<any>`
    display: flex;
    justify-content: center;
    margin-top: 29px;
  `,
};
